import React from 'react';
import { HelpHero } from '../components/HelpHero';
import { CategoryCard } from '../components/CategoryCard';
import { HelpCircle, RefreshCw, Tag, CreditCard, Truck, FileText } from 'lucide-react';
export function HelpCenter() {
  const categories = [{
    title: 'Preguntas Frecuentes',
    description: 'Respuestas rápidas a las dudas más comunes sobre pedidos, envíos y servicios.',
    icon: <HelpCircle className="h-8 w-8" data-id="element-333" />,
    href: '/preguntas-frecuentes'
  }, {
    title: 'Compras Recurrentes',
    description: 'Todo sobre suscripciones, recordatorios y cómo automatizar tus medicamentos.',
    icon: <RefreshCw className="h-8 w-8" data-id="element-334" />,
    href: '/compras-recurrentes'
  }, {
    title: 'Promociones y Descuentos',
    description: 'Aprende a usar cupones, programas de lealtad y aprovecha nuestras ofertas.',
    icon: <Tag className="h-8 w-8" data-id="element-335" />,
    href: '/promociones-y-descuentos'
  }, {
    title: 'Pagos y Facturas',
    description: 'Métodos de pago aceptados, proceso de facturación y solución de problemas.',
    icon: <CreditCard className="h-8 w-8" data-id="element-336" />,
    href: '/pagos-y-facturas'
  }];
  const popularArticles = [{
    title: '¿Cómo puedo generar un pedido?',
    icon: <FileText className="h-4 w-4" data-id="element-337" />,
    href: '/como-puedo-generar-un-pedido-en-vitau'
  }, {
    title: 'Tiempos de entrega y costos',
    icon: <Truck className="h-4 w-4" data-id="element-338" />,
    href: '/tiempos-de-entrega'
  }, {
    title: '¿Cómo facturar mi compra?',
    icon: <FileText className="h-4 w-4" data-id="element-339" />,
    href: '/como-puedo-pedir-la-factura-de-mi-pedido'
  }, {
    title: 'Política de devoluciones',
    icon: <FileText className="h-4 w-4" data-id="element-340" />,
    href: '/se-aceptan-devoluciones'
  }];
  return <div className="min-h-screen bg-[#f8fafc]" data-id="element-341">
      <HelpHero data-id="element-342" />

      <main className="max-w-7xl mx-auto px-4 md:px-8 -mt-10 relative z-20 pb-20" data-id="element-343">
        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-344">
          {categories.map((category, index) => <CategoryCard key={index} {...category} data-id="element-345" />)}
        </div>

        {/* Popular Articles Section */}
        <div className="max-w-4xl mx-auto" data-id="element-346">
          <h2 className="text-2xl font-bold text-[#022a3b] mb-8 text-center" data-id="element-347">
            Artículos Populares
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-348">
            {popularArticles.map((article, index) => <a key={index} href={article.href} className="flex items-center p-4 bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md hover:border-[#0af]/30 transition-all group" data-id="element-349">
                <div className="bg-gray-50 p-2 rounded-full text-gray-500 group-hover:text-[#0af] group-hover:bg-[#f0f9ff] transition-colors mr-4" data-id="element-350">
                  {article.icon}
                </div>
                <span className="text-gray-700 font-medium group-hover:text-[#0af] transition-colors" data-id="element-351">
                  {article.title}
                </span>
              </a>)}
          </div>
        </div>

        {/* Contact CTA */}
        <div className="mt-20 text-center bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-352">
          <h2 className="text-2xl font-bold text-[#022a3b] mb-4" data-id="element-353">
            ¿No encuentras lo que buscas?
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-354">
            Nuestro equipo de farmacéuticos y soporte está listo para ayudarte
            con cualquier duda específica que tengas.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-355">
            <a href="https://wa.me/528148007977?text=Tengo%20una%20duda" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#25D366] hover:bg-[#128C7E] transition-colors" data-id="element-356">
              Chat en WhatsApp
            </a>
            <a href="mailto:info@vitau.mx" className="inline-flex items-center justify-center px-6 py-3 border border-[#022a3b] text-base font-medium rounded-md text-[#022a3b] bg-white hover:bg-gray-50 transition-colors" data-id="element-357">
              Enviar correo
            </a>
          </div>
        </div>
      </main>
    </div>;
}